import { render } from "./auth-layout.vue?vue&type=template&id=1a5fd97e"
import script from "./auth-layout.vue?vue&type=script&lang=js"
export * from "./auth-layout.vue?vue&type=script&lang=js"

import "./auth-layout.vue?vue&type=style&index=0&id=1a5fd97e&lang=scss"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__